import './App.css';
import {ToastContainer} from 'react-toastify';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppLockerXMLParser } from "./Pages/AppLockerXMLParser";
import { Dashboard } from "./Pages/Dashboard";
import { HybridRecipientManagement } from "./Pages/HybridRecipientManagement";

import '@tabler/core/dist/css/tabler.min.css';
import Layout from "./Components/Default/Layout";
import {useEffect} from "react";


function App() {
    useEffect(() => {
        // Setze das Theme fest auf light
        document.body.setAttribute('data-bs-theme', 'light');
        localStorage.setItem('tablerTheme', 'light');
    }, []);

  return (
      <Router>
          <ToastContainer closeOnClick/>
        <Routes>
            <Route path="/" element={<Layout />} >
                <Route path="/" element={<Dashboard />} />
                <Route path="/tools/AppLockerXMLParser" element={<AppLockerXMLParser />} />
                <Route path="/tools/HybridRecipientManagement" element={<HybridRecipientManagement />} />
            </Route>
        </Routes>
      </Router>
  );
}

export default App;